<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'

import arrowRight from '@/assets/svg/arrow-right.svg'
import arrowTop from '@/assets/svg/arrow-top.svg'
import arrowTopRight from '@/assets/svg/arrow-top-right.svg'
import chevron from '@/assets/svg/chevron.svg'
import cross from '@/assets/svg/cross.svg'
import discord from '@/assets/svg/discord.svg'
import facebook from '@/assets/svg/facebook.svg'
import instagram from '@/assets/svg/instagram.svg'
import linkedin from '@/assets/svg/linkedin.svg'
import medium from '@/assets/svg/medium.svg'
import play from '@/assets/svg/play.svg'
import segment from '@/assets/svg/segment.svg'
import shuffle from '@/assets/svg/shuffle.svg'
import smiley from '@/assets/svg/smiley.svg'
import spatial from '@/assets/svg/spatial.svg'
import twitter from '@/assets/svg/twitter.svg'
import universe from '@/assets/svg/universe.svg'

export const icons = {
  arrowRight,
  arrowLeft: arrowRight,
  arrowTopRight,
  arrowTop,
  arrowBottom: arrowTop,
  chevron,
  cross,
  discord,
  facebook,
  instagram,
  linkedin,
  medium,
  play,
  segment,
  shuffle,
  smiley,
  spatial,
  twitter,
  universe
}

export default defineComponent({
  name: 'IconComponent',
  props: {
    icon: { type: String as PropType<keyof typeof icons>, required: true }
  },
  setup (props) {
    return {
      component: computed(() => icons[props.icon])
    }
  }
})
</script>

<template>
  <component :is="component" class="icon inline-block" :class="{[icon]: true}" />
</template>

<style lang="scss" scoped>
.arrowLeft {
  transform: rotate(180deg);
}

.arrowBottom {
  transform: rotate(180deg);
}
</style>
